import React from "react";
import {components} from "react-select";

export default function CustomOptionWithGtm(props) {
    const { data, gtmEventRegion, gtmEventElement, showImages } = props;

    const renderImageContent = () => {
        if(showImages) {
            if(data.image) {
                return (
                    <img
                        src={data.image}
                        alt={data.label}
                        style={{
                            maxWidth: 20,
                            maxHeight: 20,
                            objectFit: 'contain',
                            borderRadius: 2,
                        }}
                    />
                )
            } else {
                return (
                    <div style={{width: 20, height: 20}}/>
                )
            }
        }
    }

    return (
        <components.Option {...props}>
            <div
                data-gtm-event-region={gtmEventRegion}
                data-gtm-event-element={gtmEventElement}
                style={data.image ? {
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px'
              } : {}}
          >
             {renderImageContent()}
            {data.label}
          </div>
        </components.Option>
    );
}